export default {
    setCategories(context, payload) {
        context.commit('setCategories', payload);
    },

    setFormatCategories(context, payload) {
        context.commit('setFormatCategories', payload);
    },

    setIndustrialCategories(context, payload) {
        context.commit('setIndustrialCategories', payload);
    },

    setInterchangeSku(context, payload) {
        context.commit('setInterchangeSku', payload);
    },
    setInterchangeManufacturers(context, payload) {
        context.commit('setInterchangeManufacturers', payload);
    },

    setWhi_smart_url(context, payload) {
        context.commit('setWhi_smart_url', payload);
    },

    setWhi_product(context, payload) {
        context.commit('setWhi_product', payload);
    },

    setCustom_attr(context, payload) {
        context.commit('setCustom_attr', payload);
    },

    setFilter_attr(context, payload) {
        context.commit('setFilter_attr', payload);
    },

}